(function () {
  function getVariantById(variantId) {
    if (!variantId) return null;

    var variantRadios = document.querySelector('variant-radios');
    if (variantRadios) {
      var jsonEl = variantRadios.querySelector('[type="application/json"]');
      if (jsonEl) {
        var variants = JSON.parse(jsonEl.textContent);
        var variant = variants.find(function (v) {
          return String(v.id) === String(variantId);
        });
        if (variant) return variant;
      }
    }

    var variantSelects = document.querySelector('variant-selects');
    if (variantSelects) {
      var selectJsonEl = variantSelects.querySelector('[type="application/json"]');
      if (selectJsonEl) {
        var selectVariants = JSON.parse(selectJsonEl.textContent);
        return (
          selectVariants.find(function (v) {
            return String(v.id) === String(variantId);
          }) || null
        );
      }
    }

    return null;
  }

  function updateVariantDisplayName(variant) {
    if (!variant) return;

    var displayName = variant.option1 || variant.title;
    var nameEl = document.getElementById('option-variant-name');
    if (nameEl) nameEl.textContent = displayName;

    ['flex-box-variant-name-id', 'flex-box-variant-name-id-sp'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) el.textContent = displayName;
    });

    document.querySelectorAll('.flex-box-variant-name').forEach(function (el) {
      el.textContent = displayName;
    });

    if (variant.featured_image && variant.featured_image.src) {
      var imageEl = document.getElementById('flex-box-variant-image-id');
      if (imageEl) imageEl.src = variant.featured_image.src;
    }
  }

  function selectVariant(variantId) {
    if (!variantId) return false;

    var variant = getVariantById(variantId);
    var selected = false;

    var variantRadios = document.querySelector('variant-radios');
    if (variantRadios && variant) {
      var radio = variantRadios.querySelector(
        'input[type="radio"][value="' + CSS.escape(variant.option1) + '"]'
      );
      if (radio) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
        selected = true;
      }
    }

    if (!selected) {
      var variantSelects = document.querySelector('variant-selects');
      if (variantSelects && variant) {
        var select = variantSelects.querySelector('select');
        if (select) {
          select.value = variant.option1;
          select.dispatchEvent(new Event('change', { bubbles: true }));
          selected = true;
        }
      }
    }

    if (!selected) {
      var hiddenInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
      if (hiddenInput) {
        hiddenInput.value = variantId;
        hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
        selected = true;
      }
    }

    if (selected) {
      updateVariantDisplayName(variant || getVariantById(variantId));
    }

    return selected;
  }

  function scrollToProductForm() {
    var target =
      document.querySelector('variant-radios') ||
      document.querySelector('variant-selects') ||
      document.querySelector('.product__info-wrapper') ||
      document.querySelector('[id^="MainProduct-"]');

    if (!target) return;

    var headerHeight = 100;
    var top = target.getBoundingClientRect().top + window.pageYOffset - headerHeight;
    window.scrollTo({ top: top, behavior: 'smooth' });
  }

  function initVariantSelectButtons() {
    document.querySelectorAll('.product-mate-lp .mates-story__select-variant').forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        var variantId = button.dataset.variantId;
        if (selectVariant(variantId)) {
          scrollToProductForm();
        }
      });
    });
  }

  function initMateLp() {
    if (!document.querySelector('.product-mate-lp')) return;
    initVariantSelectButtons();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMateLp);
  } else {
    initMateLp();
  }
})();
